import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Navbar({ page }) {
  const [open, setOpen] = useState(false);

  return (
    <div className='h-14 bg-orange flex flex-col md:flex-row items-center'>
        <div className='p-2 w-full md:w-1/2 flex justify-between md:justify-start items-center'>
            <h1 className='text-3xl text-white font-open-sans font-medium'>Shiv Traders</h1>
            <img className='h-[40px] w-[40px] invert md:hidden' onClick={() => {setOpen(!open)}}
            src="https://res.cloudinary.com/dr61rg1rq/image/upload/v1708412284/Shiv-Traders/Assets/Icons/zszsruamu3tccgzo4or4.png"
            alt="menu" />
        </div>
        { open && <div className='z-10 w-full flex flex-col item-center'>
          { page !== 'home' && 
            <Link 
              className='w-full flex items-center justify-center h-14 bg-orange text-2xl text-white font-roboto font-light border-t-2 border-white' 
              to='/'>Home</Link> }
          { page !== 'about' && 
            <Link 
              className='w-full flex items-center justify-center h-14 bg-orange text-2xl text-white font-roboto font-light border-t-2 border-white' 
              to='/aboutus'>About Us</Link> }
          { page !== 'products' && 
            <Link 
              className='w-full flex items-center justify-center h-14 bg-orange text-2xl text-white font-roboto font-light border-t-2 border-white' 
              to='/products'>Products</Link>}
          { page !== 'brands'&& 
            <Link 
              className='w-full flex items-center justify-center h-14 bg-orange text-2xl text-white font-roboto font-light border-t-2 border-white' 
              to='/brands'>Brands</Link>}
          { page !== 'contact' && 
            <Link 
              className='w-full flex items-center justify-center h-14 bg-orange text-2xl text-white font-roboto font-light border-t-2 border-white' 
              to='/contactus'>Contact Us</Link>}
        </div> }
        <div className='hidden md:p-3 md:w-1/2 md:flex md:items-center md:justify-end md:gap-4'>
          { page !== 'home' && <Link className='text-xl text-white font-open-sans font-light lg:font-medium' to='/'>Home</Link> }
          { page !== 'about' && <Link className='text-xl text-white font-open-sans font-light lg:font-medium' to='/aboutus'>About Us</Link> }
          { page !== 'products' && <Link className='text-xl text-white font-open-sans font-light lg:font-medium' to='/products'>Products</Link> }
          { page !== 'brands' && <Link className='text-xl text-white font-open-sans font-light lg:font-medium' to='/brands'>Brands</Link> }
          { page !== 'contact' && <Link className='text-xl text-white font-open-sans font-light lg:font-medium' to='/contactus'>Contact Us</Link> }
        </div>
    </div>
  )
}

export default Navbar